import { render, staticRenderFns } from "./InquiryWizard.vue?vue&type=template&id=6f5a97be&scoped=true&"
import script from "./InquiryWizard.vue?vue&type=script&lang=js&"
export * from "./InquiryWizard.vue?vue&type=script&lang=js&"
import style0 from "./InquiryWizard.vue?vue&type=style&index=0&id=6f5a97be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5a97be",
  null
  
)

export default component.exports